'use client';

import { c as _c } from "react/compiler-runtime";
import { HoverCard as HoverCardPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
function HoverCard(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <HoverCardPrimitive.Root data-slot="hover-card" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function HoverCardTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
const hoverCard = tv({
  base: `
    animate-in
    fade-in-0
    zoom-in-95
    data-[state=closed]:animate-out
    data-[state=closed]:fade-out-0
    data-[state=closed]:zoom-out-95
    data-[side=bottom]:slide-in-from-top-2
    data-[side=left]:slide-in-from-right-2
    data-[side=right]:slide-in-from-left-2
    data-[side=top]:slide-in-from-bottom-2
    bg-background-primary
    text-content-primary
    border
    border-border-secondary
    shadow-popover
    z-50
    w-64
    origin-(--radix-hover-card-content-transform-origin)
    rounded-md
    p-4
    outline-hidden
  `
});
function HoverCardContent(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      align: t1,
      sideOffset: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  let t3;
  if ($[5] !== className) {
    t3 = hoverCard({
      className
    });
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== align || $[8] !== props || $[9] !== sideOffset || $[10] !== t3) {
    t4 = <HoverCardPrimitive.Portal><HoverCardPrimitive.Content className={t3} align={align} collisionPadding={6} data-slot="hover-card-content" sideOffset={sideOffset} {...props} /></HoverCardPrimitive.Portal>;
    $[7] = align;
    $[8] = props;
    $[9] = sideOffset;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { HoverCard, HoverCardTrigger, HoverCardContent };